// extracted by mini-css-extract-plugin
export default {"meal":"SkillsItem_meal__WKg2A","description":"SkillsItem_description__CV4-y"};